<div id="charts" class="page-layout emma simple carded fullwidth">
    <div class="header accent">
        <h1>{{ "CHARTS.Title" | translate }}</h1>
    </div>

    <div class="center">
        @if (showNoProjectState) {
            <div class="content-card charts-empty">{{ "CHARTS.NoProjectSelected" | translate }}</div>
        } @else if (showNoDevicesState) {
            <div class="content-card charts-empty">{{ "CHARTS.NoDevicesAvailable" | translate }}</div>
        } @else {
            <div class="content-card charts-card">
                <div class="charts-config">
                    <div class="config-stack">
                        <div class="config-group">
                            <div class="config-group__header">{{ "CHARTS.ChartConfiguration" | translate }}</div>

                            <div class="row">
                                <div class="controls controls--dates">
                                    <div class="section-label">{{ "REPORT.Dates" | translate }}</div>
                                    <mat-form-field>
                                        <mat-select
                                            placeholder="{{ 'DEVICE.DateRange' | translate }}"
                                            [(value)]="dateRange"
                                            (selectionChange)="onDateRangeChange()"
                                        >
                                            <mat-option value="last15minutes">{{ "DEVICE.Last15Minutes" | translate }}</mat-option>
                                            <mat-option value="lasthour">{{ "DEVICE.LastHour" | translate }}</mat-option>
                                            <mat-option value="last4hours">{{ "DEVICE.Last4Hours" | translate }}</mat-option>
                                            <mat-option value="last12hours">{{ "DEVICE.Last12Hours" | translate }}</mat-option>
                                            <mat-option value="last24hours">{{ "DEVICE.Last24Hours" | translate }}</mat-option>
                                            <mat-option value="custom">{{ "DEVICE.Custom" | translate }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    @if (dateRange === "custom") {
                                        <mat-form-field class="date-field">
                                            <input
                                                matInput
                                                [matDatepicker]="start"
                                                placeholder="{{ 'DEVICE.StartDate' | translate }}"
                                                [(ngModel)]="startDate"
                                                (dateChange)="onDateRangeChange()"
                                                (dateInput)="updateEndDate()"
                                            />
                                            <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                                            <mat-datepicker #start></mat-datepicker>
                                        </mat-form-field>

                                        <mat-form-field class="date-field date-field--time">
                                            <input
                                                matInput
                                                type="time"
                                                [(ngModel)]="startTime"
                                                placeholder="{{ 'DEVICE.StartTime' | translate }}"
                                                step="300"
                                                (change)="onDateRangeChange()"
                                            />
                                        </mat-form-field>

                                        <mat-form-field class="date-field">
                                            <input
                                                matInput
                                                [matDatepicker]="end"
                                                placeholder="{{ 'DEVICE.EndDate' | translate }}"
                                                [min]="endDateMin"
                                                [max]="endDateMax"
                                                [(ngModel)]="endDate"
                                                (dateChange)="onDateRangeChange()"
                                            />
                                            <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                                            <mat-datepicker #end></mat-datepicker>
                                        </mat-form-field>

                                        <mat-form-field class="date-field date-field--time">
                                            <input
                                                matInput
                                                type="time"
                                                [(ngModel)]="endTime"
                                                placeholder="{{ 'DEVICE.EndTime' | translate }}"
                                                step="300"
                                                (change)="onDateRangeChange()"
                                            />
                                        </mat-form-field>
                                    }

                                    <mat-form-field>
                                        <mat-select
                                            placeholder="{{ 'DEVICE.DataAggregation' | translate }}"
                                            [(value)]="groupingData"
                                            (selectionChange)="loadChartData()"
                                        >
                                            @if (enableInstantValues) {
                                                <mat-option value="no">{{ "DEVICE.NoAggregation" | translate }}</mat-option>
                                            }
                                            <mat-option value="5minutes">{{ "DEVICE.Minutes5" | translate }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            @if (alarmOptions.length > 0) {
                                <div class="row row--divider">
                                    <div class="section-label">{{ "TAB.Alarms" | translate }}</div>
                                    <div class="display-options display-options--alarms">
                                        @for (alarm of alarmOptions; track alarm.key) {
                                            <mat-slide-toggle [(ngModel)]="alarm.selected" (change)="onAlarmSelectionChange()">
                                                {{ alarm.label }}
                                            </mat-slide-toggle>
                                        }
                                    </div>
                                </div>
                            }
                        </div>

                        <div class="config-group">
                            <div class="config-group__header">{{ "CHARTS.SeriesConfiguration" | translate }}</div>

                            <div class="row">
                                <div class="section-label">{{ "CHARTS.AddSeries" | translate }}</div>
                                <div class="series-builder">
                                    <mat-form-field>
                                        <mat-label>{{ "CHARTS.Devices" | translate }}</mat-label>
                                        <mat-select [(value)]="selectedSeriesDeviceId" (selectionChange)="onSeriesBuilderDeviceChange()">
                                            @for (device of devices; track device.id) {
                                                <mat-option [value]="device.id">{{ device.deviceName }}</mat-option>
                                            }
                                        </mat-select>
                                        <mat-hint>{{ "CHARTS.DevicesHint" | translate }}</mat-hint>
                                    </mat-form-field>

                                    <mat-form-field>
                                        <mat-label>{{ "CHARTS.DataPoint" | translate }}</mat-label>
                                        <mat-select [(value)]="selectedMetricKey" [disabled]="availableMetricOptions.length === 0">
                                            @for (metric of availableMetricOptions; track metric.key) {
                                                <mat-option [value]="metric.key">{{ metric.label }}</mat-option>
                                            }
                                        </mat-select>
                                        <mat-hint>{{ "CHARTS.DataPointHint" | translate }}</mat-hint>
                                    </mat-form-field>

                                    <div class="series-builder__action">
                                        <button mat-stroked-button color="primary" [disabled]="!canAddSeries" (click)="addSeries()">
                                            {{ "CHARTS.AddButton" | translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            @if (seriesConfigs.length > 0) {
                                <div class="row row--divider">
                                    <div class="section-label">{{ "CHARTS.Series" | translate }}</div>
                                    <div class="field-selection-panel">
                                        <table class="field-selection-table">
                                            <thead>
                                                <tr>
                                                    <th>{{ "CHARTS.Device" | translate }}</th>
                                                    <th>{{ "CHARTS.DataPoint" | translate }}</th>
                                                    <th>{{ "REPORT.Color" | translate }}</th>
                                                    <th>{{ "REPORT.LineStyle" | translate }}</th>
                                                    <th class="field-selection-cell field-selection-cell--actions">
                                                        {{ "CHARTS.Actions" | translate }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                @for (series of seriesConfigs; track series.key) {
                                                    <tr>
                                                        <td>{{ series.deviceName }}</td>
                                                        <td>
                                                            {{ "FIELD." + series.dataType | translate }}
                                                            @if (series.variant !== "base") {
                                                                <span class="series-variant">({{ series.variant }})</span>
                                                            }
                                                        </td>
                                                        <td class="field-selection-cell">
                                                            <input
                                                                class="field-selection-color-input"
                                                                type="color"
                                                                [(ngModel)]="series.color"
                                                                (change)="onSeriesStyleChange()"
                                                            />
                                                        </td>
                                                        <td class="field-selection-cell">
                                                            <select
                                                                class="field-selection-style-select"
                                                                [(ngModel)]="series.lineStyle"
                                                                (change)="onSeriesStyleChange()"
                                                            >
                                                                @for (option of chartLineStyleOptions; track option.value) {
                                                                    <option [ngValue]="option.value">
                                                                        {{ option.labelKey | translate }}
                                                                    </option>
                                                                }
                                                            </select>
                                                        </td>
                                                        <td class="field-selection-cell field-selection-cell--actions">
                                                            <button
                                                                mat-icon-button
                                                                color="warn"
                                                                type="button"
                                                                (click)="removeSeries(series.key)"
                                                                [attr.aria-label]="'Remove ' + series.deviceName"
                                                            >
                                                                <mat-icon>delete_outline</mat-icon>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div class="chart-surface">
                    @if (loading) {
                        <div class="chart-state">
                            <mat-spinner diameter="36"></mat-spinner>
                        </div>
                    } @else if (seriesConfigs.length === 0) {
                        <div class="chart-state">{{ "CHARTS.NoSeriesSelected" | translate }}</div>
                    } @else if (!hasChartData) {
                        <div class="chart-state">{{ "CHARTS.NoChartData" | translate }}</div>
                    } @else {
                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [constructorType]="'stockChart'"
                            [options]="chart"
                            [(update)]="chartUpdate"
                            [oneToOne]="true"
                            [callbackFunction]="chartCallback"
                            style="width: 100%; display: block"
                        ></highcharts-chart>
                    }
                </div>
            </div>
        }
    </div>
</div>
